module.exports = __webpack_public_path__ + "img/culture.a18acfa2.jpg";